"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchInfoSection = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _PrettyJson = require("./PrettyJson");
var _ResponseBodySection = require("./ResponseBodySection");
var _jsxRuntime = require("react/jsx-runtime");
const FetchInfoSection = ({
  fetchInfo
}) => {
  if (!fetchInfo || Object.keys(fetchInfo).length === 0) {
    return null;
  }
  const {
    responseBody,
    ...info
  } = fetchInfo;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    mb: 3,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Accordion, {
      defaultExpanded: true,
      disableGutters: true,
      elevation: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionSummary, {
        expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDown, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          gutterBottom: true,
          variant: "subtitle1",
          flexGrow: 1,
          textAlign: "center",
          children: "Fetch Info"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionDetails, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrettyJson.PrettyJson, {
          value: info
        })
      })]
    }), responseBody != null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Accordion, {
      defaultExpanded: true,
      disableGutters: true,
      elevation: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionSummary, {
        expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDown, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          gutterBottom: true,
          variant: "subtitle2",
          flexGrow: 1,
          textAlign: "center",
          children: "Response"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionDetails, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponseBodySection.ResponseBodySection, {
          responseBody: responseBody
        })
      })]
    }) : undefined]
  });
};
exports.FetchInfoSection = FetchInfoSection;
